var map = {
	"./bus.gif": "90d2",
	"./calls.gif": "488e",
	"./committees.gif": "dd4d",
	"./degrees.gif": "64a6",
	"./lessons.gif": "edfc",
	"./masrufi.gif": "cd5a",
	"./mentors.gif": "5944",
	"./results.gif": "3621",
	"./schoolbus.gif": "983d",
	"./students.gif": "0009",
	"./table.gif": "acd1",
	"./teachers.gif": "30bd",
	"./whatsapp.gif": "39bdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3d2";